export const enum InvalidFields {
  input,
  units,
  both,
  none,
}
